// const axiosLink = "http://localhost:5010";

// const axiosLink =  "https://web.isocium.com";
const axiosLink =  "https://captaincandy.eu";



export { axiosLink };
